<template>
  <div>
    <v-dialog v-model="dialog" max-width="500" :fullscreen="isMobile" persistent>
      <template v-slot:activator="{ on, attrs }">
        <div v-if="icon">
          <v-btn fab dark icon x-small color="primary" v-bind="attrs" v-on="on" v-if="location.lat && location.lng" >
          <v-icon dark>fa-solid fa-location-dot</v-icon>
        </v-btn>
        </div>
        <div v-else>
          <v-btn color="primary" v-bind="attrs" v-on="on">
            VER UBICACIÓN
            <v-icon
              right
              dark
            >
            fa-solid fa-map-location-dot
            </v-icon>
          </v-btn>
        </div>
        
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">{{ title }}</span>
        </v-card-title>

        <v-sheet class="overflow-y-auto" :style="{ maxHeight: height + 'px' }">
          <div v-if="error" class="error">{{ error }}</div>
          <div v-else-if="location">
            <gmap-map
              :center="location"
              :zoom="15"
              :style="{ height: height + 'px' }"
            >
              <gmap-marker :position="location"></gmap-marker>
            </gmap-map>
          </div>
          <div v-else>
            Obteniendo ubicación...
          </div>
        </v-sheet>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="openInMaps">Ver en google Maps</v-btn>
          <v-btn color="primary" text @click="resetSelection">Cerrar</v-btn>
         
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "Mi Ubicación",
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    height: {
      type: Number,
      default: 500,
    },
    location: {
      type: Object,
      default: null,
    },
    icon: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      error: null,
      dialog: false,
    };
  },
  methods: {
    resetSelection() {
      this.dialog = false;
      this.$emit('reset');
    },
    
    openInMaps() {
      if (this.location && this.location.lat && this.location.lng) {
        // Crear URL de Google Maps con las coordenadas
        const url = `https://www.google.com/maps/search/?api=1&query=${this.location.lat},${this.location.lng}`;
        
        // Abrir en una nueva ventana/pestaña
        window.open(url, '_blank');
      } else {
        // Mostrar error si no hay ubicación válida
        this.error = 'No se puede abrir el mapa: ubicación no válida';
        
        // Limpiar el error después de 3 segundos
        setTimeout(() => {
          this.error = null;
        }, 3000);
      }
    },
    
  },
};
</script>

<style scoped>
.error {
  color: red;
}
</style>